var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"corner top-left"}),_c('div',{staticClass:"corner top-right"}),_c('div',{staticClass:"corner bottom-left"}),_c('div',{staticClass:"corner bottom-right"})])
}]

export { render, staticRenderFns }